"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isByteLength = void 0;
const assertString_1 = require("./util/assertString");
/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
    (0, assertString_1.assertString)(str);
    let min;
    let max;
    if (typeof (options) === 'object') {
        min = options.min || 0;
        max = options.max;
    }
    else { // backwards compatibility: isByteLength(str, min [, max])
        min = arguments[1];
        max = arguments[2];
    }
    const len = encodeURI(str).split(/%..|./).length - 1;
    return len >= min && (typeof max === 'undefined' || len <= max);
}
exports.isByteLength = isByteLength;
